import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {useTranslation} from '@/translations/i18n'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {DashboardConsultantSearchParams} from '../../types'
import {useGetDashboardConsultants} from '../../query/useGetDashboardConsultants'
import {useMemo} from 'react'
import {ProgressBar} from '@/components/ui/progress-bar/ProgressBar'
import {formatNumber} from '@/utilities/helpers'

export const DashboardConsultantHoursStats = () => {
    const {t} = useTranslation()
    const {searchParams} = useParsedSearchParams(DashboardConsultantSearchParams)
    const {data} = useGetDashboardConsultants(
        {
            fields: ['hours'],
            ...searchParams
        },
        {enabled: !!searchParams.consultant}
    )

    const percentage = useMemo(() => {
        if (!data) return 0
        return ((data.hours?.done ?? 0) / (data.hours?.planned ?? 0)) * 100
    }, [data])

    return (
        <Flexbox direction="column" gap={2} fullWidth>
            <Flexbox justify="space-between" align="center" fullWidth>
                <Flexbox gap={1} align="center">
                    <Text size="textSm" palette="neutral" shade="950">
                        {t('dashboard:hours_stats_progress_title_1')} / {t('dashboard:hours_stats_progress_title_2')}
                    </Text>
                    <Text size="textSm" palette="neutral" shade="700" weight={700}>
                        ({percentage.toFixed(1)}%)
                    </Text>
                </Flexbox>
                <Flexbox align="center" gap={1}>
                    <Text palette="neutral" shade="900" size="displaySm" weight={700}>
                        {t('commons:x_of_y', {
                            x: formatNumber(data?.hours?.done ?? 0),
                            y: formatNumber(data?.hours?.planned ?? 0)
                        })}
                    </Text>
                </Flexbox>
            </Flexbox>
            <ProgressBar percentage={percentage} rounded variant="success" />
        </Flexbox>
    )
}
